import MetaTags from "./index";
import { useMemo } from "react";

const tags = {
  index: {
    vod: {
      title: "お問い合わせ | SPOOX(スプークス)",
      keywords: "SPOOX,スプークス,動画配信,見放題,レンタル",
      description:
        "SPOOX(スプークス)に関するお問い合わせはこちらから。SPOOX(スプークス)では、スポーツや映画やアニメなど、様々な動画を配信中です。",
      og: { type: "article" },
    },
  },
  confirm: {
    vod: {
      title: "お問い合わせ内容確認 | SPOOX(スプークス)",
      keywords: "SPOOX,スプークス,動画配信,見放題,レンタル",
      description:
        "お問い合わせ内容確認。SPOOX(スプークス)では、スポーツや映画やアニメなど、様々な動画を配信中です。",
      og: { type: "article" },
    },
  },
  complete: {
    vod: {
      title: "お問い合わせ完了 | SPOOX(スプークス)",
      keywords: "SPOOX,スプークス,動画配信,見放題,レンタル",
      description:
        "お問い合わせ完了。SPOOX(スプークス)では、スポーツや映画やアニメなど、様々な動画を配信中です。",
      og: { type: "article" },
    },
  },
};

export default function InquiryMetaTags({ action }) {
  const props = tags[action]["vod"];

  const noindex = useMemo(() => {
    if (action === "confirm" || action === "complete") return "noindex";
    return null;
  }, [action]);

  return <MetaTags {...props} robots={noindex} />;
}
